export default "__VITE_ASSET__9AKpKRQm__"